"use strict";

var _defineProperty = require("/root/bj.onlive.vn/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var preact_1 = require("preact");

var preact_motion_1 = require("preact-motion");

var hooks_1 = require("preact/hooks");

var utils_1 = require("./utils");

function ScrollBar(props) {
  var dragRef = hooks_1.useRef({
    isDragging: false,
    lastClientPosition: 0
  });
  var scrollbarContainerRef = hooks_1.useRef();
  var isHoriziontal = hooks_1.useCallback(function () {
    return props.type === "horizontal";
  }, []);
  var isVertical = hooks_1.useCallback(function () {
    return props.type === "vertical";
  }, []);
  var calculateFractionalPosition = hooks_1.useCallback(function (realContentSize, containerSize, contentPosition) {
    var relativeSize = realContentSize - containerSize;
    return 1 - (relativeSize - contentPosition) / relativeSize;
  }, []);
  var calculateState = hooks_1.useCallback(function (props) {
    var fractionalPosition = calculateFractionalPosition(props.realSize, props.containerSize, props.position);
    var proportionalToPageScrollSize = props.containerSize * props.containerSize / props.realSize;
    var scrollSize = proportionalToPageScrollSize < props.minScrollSize ? props.minScrollSize : proportionalToPageScrollSize;
    var scrollPosition = (props.containerSize - scrollSize) * fractionalPosition;
    return {
      scrollSize: scrollSize,
      position: Math.round(scrollPosition)
    };
  }, [calculateFractionalPosition, props.realSize, props.containerSize, props.minScrollSize]);
  var state = hooks_1.useMemo(function () {
    return calculateState(props);
  }, [props, calculateState]);
  var computeMultiplier = hooks_1.useCallback(function () {
    return props.containerSize / props.realSize;
  }, [props.containerSize, props.realSize]);
  var handleScrollBarContainerClick = hooks_1.useCallback(function (e) {
    e.preventDefault();
    var multiplier = computeMultiplier();
    var clientPosition = isVertical() ? e.clientY : e.clientX;

    var _scrollbarContainerRe = scrollbarContainerRef.current.getBoundingClientRect(),
        top = _scrollbarContainerRe.top,
        left = _scrollbarContainerRe.left;

    var clientScrollPosition = isVertical() ? top : left;
    var position = clientPosition - clientScrollPosition;
    var proportionalToPageScrollSize = props.containerSize * props.containerSize / props.realSize;
    props.onPositionChange((position - proportionalToPageScrollSize / 2) / multiplier);
  }, [computeMultiplier, isVertical]);
  var handleMouseMoveForHorizontal = hooks_1.useCallback(function (e) {
    var multiplier = computeMultiplier();

    if (dragRef.current.isDragging) {
      e.preventDefault();
      var deltaX = dragRef.current.lastClientPosition - e.clientY;
      props.onMove(deltaX / multiplier, 0);
    }
  }, [computeMultiplier]);
  var handleMouseMoveForVertical = hooks_1.useCallback(function (e) {
    if (dragRef.current.isDragging) {
      var multiplier = computeMultiplier();
      e.preventDefault();
      var deltaY = dragRef.current.lastClientPosition - e.clientY;
      props.onMove(0, deltaY / multiplier);
    }
  }, [computeMultiplier, dragRef.current.isDragging, dragRef.current.lastClientPosition]);
  var handleMouseDown = hooks_1.useCallback(function (e) {
    e.preventDefault();
    e.stopPropagation();
    var lastClientPosition = isVertical() ? e.clientY : e.clientX;
    dragRef.current = {
      isDragging: true,
      lastClientPosition: lastClientPosition
    };
    props.onFocus();
  }, [isVertical]);
  var handleMouseUp = hooks_1.useCallback(function (e) {
    if (dragRef.current.isDragging) {
      e.preventDefault();
      dragRef.current = {
        isDragging: false,
        lastClientPosition: 0
      };
    }
  }, [dragRef.current.isDragging]);
  hooks_1.useEffect(function () {
    if (props.type === "vertical") {
      props.ownerDocument.addEventListener("mousemove", handleMouseMoveForVertical);
    } else {
      props.ownerDocument.addEventListener("mousemove", handleMouseMoveForHorizontal);
    }

    props.ownerDocument.addEventListener("mouseup", handleMouseUp);
    return function () {
      if (props.type === "vertical") {
        props.ownerDocument.removeEventListener("mousemove", handleMouseMoveForVertical);
      } else {
        props.ownerDocument.removeEventListener("mousemove", handleMouseMoveForHorizontal);
      }

      props.ownerDocument.removeEventListener("mouseup", handleMouseUp);
    };
  }, [props.type, handleMouseMoveForHorizontal, handleMouseMoveForVertical, handleMouseUp]);
  var createScrollStyles = hooks_1.useCallback(function () {
    if (props.type === "vertical") {
      return {
        height: state.scrollSize,
        marginTop: state.position
      };
    } else {
      return {
        width: state.scrollSize,
        marginLeft: state.position
      };
    }
  }, [state, props.type]);
  var scrollbarClasses = hooks_1.useMemo(function () {
    return "scrollbar-container ".concat(dragRef.current.isDragging ? "active" : "", " ").concat(isHoriziontal() ? "horizontal" : "", " ").concat(isVertical() ? "vertical" : "");
  }, [dragRef.current.isDragging, isHoriziontal, isVertical]);
  var scrollStyles = createScrollStyles();
  var springifiedScrollStyles = props.smoothScrolling ? utils_1.modifyObjValues(scrollStyles, function (x) {
    return preact_motion_1.spring(x);
  }) : scrollStyles;
  return preact_1.h(preact_motion_1.Motion, {
    style: springifiedScrollStyles
  }, [function (style) {
    return preact_1.h("div", {
      className: scrollbarClasses,
      style: props.containerStyle,
      ref: scrollbarContainerRef,
      onMouseDown: handleScrollBarContainerClick,
      role: "button",
      tabIndex: "-1"
    }, preact_1.h("div", {
      className: "scrollbar",
      style: _objectSpread({}, props.scrollbarStyle, {}, style),
      onMouseDown: handleMouseDown,
      role: "button",
      tabIndex: "-1"
    }));
  }]);
}

exports.default = ScrollBar;